import { SVGAttributes } from 'react';

type Props = SVGAttributes<SVGElement>;

export function BrandHandMarkArrowVariant1(props: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="263"
            height="28"
            viewBox="0 0 263 28"
            fill="currentColor"
            {...props}
        >
            <path d="M230.485 13.8378C230.19 14.18 222.918 14.3544 221.587 14.3753C199.228 14.6483 176.832 13.7594 154.467 14.0973C102.886 14.8801 51.4697 18.6292 0.0156422 21.4349C-0.111428 19.4119 0.540948 20.307 1.78122 20.1023C3.75271 19.7734 5.84316 19.7842 7.84285 19.6111C42.3185 16.6506 78.3141 14.846 112.923 13.625C150.945 12.2619 225.598 13.2437 227.058 12.7985C228.518 12.3534 224.816 11.4616 225.807 10.9044C226.799 10.3473 231.688 12.4711 230.485 13.8378Z" />
            <path d="M233.083 25.699C233.083 25.699 232.255 28.1298 231.352 26.6854C230.019 24.5209 235.758 22.8832 237.216 22.4597C243.285 20.7892 249.406 21.2435 255.305 20.1899C258.676 19.5847 263.922 18.5318 258.529 16.2267C246.382 11.0446 231.38 8.52919 219.11 2.83224C215.424 1.98586 219.619 4.74008 216.881 4.66514C216.881 4.66514 210.155 0.632698 214.146 0.154521C218.136 -0.323656 259.553 15.3449 262.071 16.5344C264.59 17.7239 261.374 20.0708 259.646 20.7953C252.194 23.9019 241.698 21.4184 233.042 25.6731L233.083 25.699Z" />
        </svg>
    );
}
